import { Component, OnInit } from '@angular/core';
import { NeproseService } from './services/neprose.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

  viewed: boolean = true

  roadBlock: any

  constructor( private neproseService: NeproseService, private sanitizer: DomSanitizer, private readonly seoSocialShareService: SeoSocialShareService,
    private readonly jsonLdService: JsonLdService ){}

  title = 'Neprose';

  ngOnInit(){
    this.seoSocialShareService.setFbAppId('721687752013453')
    this.seoSocialShareService.setTwitterCard('summary')
    this.seoSocialShareService.setTwitterSiteCreator('@neprose')
    const jsonLdObject = this.jsonLdService.getObject('Website', {
      name: 'Neprose Property Service',
      url: environment.url,
    })
    this.jsonLdService.setData(jsonLdObject)
    this.neproseService.getRoadBlock().subscribe(data => {
      if(data && data.roadBlock){
        this.viewed = false
        data.roadBlock.imagePath = environment.api + '/images/' + data.roadBlock.imagePath
        data.roadBlock.link = this.sanitizer.bypassSecurityTrustUrl(data.roadBlock.link)
        this.roadBlock = data.roadBlock
      }
    })

  }

  close(){
    this.viewed = true
  }

}
